import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { DishServices } from '../../../dish/services';
import { TranslateService } from '@ngx-translate/core';
import { MenuServices } from '../../../menu/services';

/**
 * Component que devuelve un datetime segun lugar (espana - usa)
 *
 */

@Component({
  selector: 'menu-edit-name',
  templateUrl: 'menu-edit-name.html',
})
export class MenuEditNamePage {

  menu_uid: any = '';
  title_es: any = '';
  title_ca: any = '';
  title_en: any = '';
  title_it: any = '';
  title_fr: any = '';
  title_de: any = '';
  subtitle_es: any = '';
  reference: any = '';

  constructor(public dishServices: DishServices,
    public globals: Globals,
    public viewCtrl: ViewController,
    public translate: TranslateService,
    public menuServices: MenuServices,
    public navParams: NavParams) {

    this.menu_uid = this.navParams.get('menu_uid');
    this.title_es = this.navParams.get('title_es');
    this.title_ca = this.navParams.get('title_ca');
    this.title_en = this.navParams.get('title_en');
    this.title_it = this.navParams.get('title_it');
    this.title_fr = this.navParams.get('title_fr');
    this.title_de = this.navParams.get('title_de');
    this.subtitle_es = this.navParams.get('subtitle_es');
    this.reference = this.navParams.get('reference');
  }

  close() {
    this.viewCtrl.dismiss();
  }

  async updateMenuName() {
    //this.globals.GAtrackView('Menu', 'Menu - Name - Update', this.globals.restaurant.email, 'Create/Update', 'Update name', 'Menu', this.title_es);
    this.menuServices.afs.collection('menus').doc(this.menu_uid).update({
      'reference': this.reference,
      'title_es': this.title_es,
      'title_en': this.title_en,
      'title_fr': this.title_fr,
      'title_de': this.title_de,
      'title_it': this.title_it,
      'title_ca': this.title_ca,
      'subtitle_es': this.subtitle_es,
      'subtitle_en': null,
      'subtitle_fr': null,
      'subtitle_it': null,
      'subtitle_de': null,
      'subtitle_ca': null,
      'updated_at': new Date(),
    }).then(() => {
      //dismis
      this.close()
    });

  }

}



// WEBPACK FOOTER //
// ./src/pages/components/popups/menu-edit-name/menu-edit-name.ts